import { THEME_COLORS } from '@st/theme/colors'
import { Rect } from '@st/geom'
import { StampTemplate, TextStampTemplateSection } from '~/st-doc-viewer/annotations'
import { recomputeStampLayoutAndStyle } from '../stamps-core/stamp-layout'
import { StampAnnotation } from '@st/sdk'

const RED = THEME_COLORS['red'][600]
const YELLOW = THEME_COLORS['yellow'][300]

const ZERO_RECT: Rect = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
}

type ReferenceStamp = { text: string; label: string; stampCode: string }

const MAX_REFERENCE_NUMBER = 15

const REFERENCES: ReferenceStamp[] = Array.from({ length: MAX_REFERENCE_NUMBER }, (_, index) => {
  const number = index + 1
  return {
    text: `R-${number}`,
    stampCode: `R-${number}`,
    label: `Reference ${number}`
  }
})

export const REFERENCE_STAMP_TEMPLATE_SECTIONS: TextStampTemplateSection[] = [
  {
    title: 'References',
    layout: 'rows',
    templates: REFERENCES.map(({ text, stampCode, label }) => ({
      id: text,
      label: label,
      category: 'cross_reference',
      annotation: recomputeStampLayoutAndStyle({
        id: text,
        text: text,
        time: '2000-01-01T00:00:00.000Z',
        stampType: 'cross_reference',
        stampCode: stampCode,
        stampSize: 12,
        color: RED,
        backgroundColor: YELLOW,
        bounds: ZERO_RECT,
        type: 'stamp',
        pageNumber: 1,
        font: {
          family: 'Helvetica',
          size: -1,
          weight: 'normal'
        }
      })
    }))
  }
]

export function findMatchingTemplate(
  annotation: StampAnnotation | undefined
): StampTemplate | undefined {
  if (!annotation) {
    return undefined
  }

  for (const section of REFERENCE_STAMP_TEMPLATE_SECTIONS) {
    for (const template of section.templates) {
      if (templateMatches(template, annotation)) {
        return template
      }
    }
  }

  function templateMatches(template: StampTemplate, annotation: StampAnnotation) {
    return (
      template.annotation.stampCode == annotation.stampCode &&
      template.annotation.stampType == annotation.stampType
    )
  }
}
